import React from 'react';
import UnifiedLogin from '@components/UnifiedLogin';

const Login = () => {
  return (
    <UnifiedLogin theme="light" isMobile={true} />
  );
};

export default Login;